import React, {useContext} from 'react'
import {TextField} from '@material-ui/core'

import useStyles from "./styles";

import PriorAuthorizationContext from '../../../../../contexts/PriorAuthorization/PriorAuthorization.context'

export default function TextAreaInput(props){

    const classes = useStyles();

    const {
            maxLength, 
            iProps,
            field,
            rows,
            width='100%',
            wordCount=true,
            ...wrapperProps
        } = props
    
    const { fields } = useContext(PriorAuthorizationContext)

    const value = field ? fields[field].value : null
    const valLength = value ? value.length : 0

    return (
        <div
            {...wrapperProps}
            style={{width: '100%', ...wrapperProps.style}}
        >
            <TextField 
                {...iProps}
                multiline
                rows={rows}
                variant='outlined'
                inputProps={{maxLength, style: {width}, "aria-label": 'Text Area'}}
                className={classes.textArea}
            />

            { wordCount && maxLength &&
            <div className={classes.charCount}>
                Characters Remaining: {maxLength-valLength}/{maxLength}
            </div>
            }
        </div>
    )
}